// extracted by mini-css-extract-plugin
export default {"block":"aBxYde","slot":"bBxYde","list":"cBxYde","external":"dBxYde","item":"eBxYde","link":"fBxYde","title":"gBxYde","header":"hBxYde"};